export const environment = {
    production: false,
    apps: {
        center: 'https://tg-center-dev-sandbox.azurewebsites.net/api',
        booking: 'https://tg-booking-dev-sandbox.azurewebsites.net/api',
        payments: 'https://tg-payments-dev-sandbox.azurewebsites.net/api',
        workout: 'https://tg-workout-dev-sandbox.azurewebsites.net/api',
        member: 'https://tg-member-dev-sandbox.azurewebsites.net/api',
        reports: 'https://tg-reports-dev-sandbox.azurewebsites.net/api',
        utilities: 'https://tg-utilities-dev-sandbox.azurewebsites.net/api',
        security:       'https://tg-security-dev-sandbox.azurewebsites.net/api',
        notification:   'https://tg-notification-dev-sandbox.azurewebsites.net/api',
    },
    tgManagerV3: 'https://tg-manager-v3-dev-sandbox.azurewebsites.net/',
    recaptchaKey : '6LcdpFQgAAAAAH-zrdDNiyXkXY8q10LgcM9wlqX7',
    recaptchaKeyV2 : '6LcdpFQgAAAAAN86Ck1pX0LXia41KWIHXuik_N5f',
    clarityId : 'rq5f33ry8x'
};
